// extracted by mini-css-extract-plugin
export var circle = "_y-2";
export var icon = "_y-a";
export var iconHighlight = "_y-0";
export var lg = "_y-8";
export var md = "_y-7";
export var outline = "_y-4";
export var sm = "_y-6";
export var square = "_y-1";
export var xl = "_y-9";
export var xs = "_y-5";
export var xxs = "_y-3";